// One message in the transcript.
//
// USER TEXT IS NEVER RENDERED AS HTML. Agent and system copy is, because the model
// is allowed a little <b> emphasis — but only after the server has escaped
// everything and re-allowed that one tag (sanitizeRich in util/sanitize.ts). The
// asymmetry is the point: what the user typed comes back to them verbatim as text,
// and what the model wrote passes a whitelist first.

export type BubbleRole = "user" | "agent" | "system";

export function Bubble({ role, html }: { role: BubbleRole; html: string }) {
  if (role === "user") {
    return (
      <div className="row user">
        <div className="bubble user">{html}</div>
      </div>
    );
  }
  return (
    <div className="row">
      <div className={`bubble ${role}`} dangerouslySetInnerHTML={{ __html: html }} />
    </div>
  );
}
